import React from 'react';
import ChatSidePanelCard from '../sidepanel/ChatSidePanelCard';
import ChatSidePanelProfileBlock from '../sidepanel/ChatSidePanelProfileBlock';

export default function ArtistProfileSidePanelCard({
  artist = null,
  detail = null,
  isLoading = false,
  title = 'プロフィール',
  avatarUrl = '',
  avatarStyle = undefined,
  onAvatarClick,
}) {
  if (!artist) {
    return null;
  }

  const displayName = artist?.name || '名称未設定';
  const email = artist?.email || '';
  const primaryPart = artist?.part_label || '';
  const fallbackPart = !primaryPart ? detail?.main_part_label || '' : '';
  const genreName = detail?.genre_name || '';
  const groupName = detail?.group_name || '';
  const prefecture = detail?.prefecture || '';
  const tags = Array.isArray(detail?.tags) ? detail.tags : [];
  const statusLabel = artist?.statusLabel || '';
  const badges = [primaryPart, !primaryPart ? fallbackPart : ''].filter(Boolean);
  const metas = [
    email,
    isLoading ? '詳細取得中...' : '',
    !isLoading && detail && genreName ? `ジャンル: ${genreName}` : '',
    !isLoading && detail && groupName ? `グループ: ${groupName}` : '',
    !isLoading && detail && prefecture ? `拠点: ${prefecture}` : '',
    !isLoading && detail && tags.length > 0
      ? `タグ: ${tags.slice(0, 3).join(', ')}${tags.length > 3 ? '…' : ''}`
      : '',
  ].filter(Boolean);

  return (
    <ChatSidePanelCard title={title}>
      <ChatSidePanelProfileBlock
        name={displayName}
        avatarUrl={avatarUrl || ''}
        avatarStyle={avatarStyle}
        avatarAlt={displayName || 'アーティスト'}
        avatarFallback={displayName?.charAt(0) || ''}
        onAvatarClick={onAvatarClick}
        badges={badges}
        metas={metas}
      />
      {statusLabel ? <div className="side-status danger">ステータス: {statusLabel}</div> : null}
    </ChatSidePanelCard>
  );
}
